/**
 * @file DEV ONLY launcher for the Mapping Review panel, in the agent
 * composer's button row, left of the gear and attachment controls. With
 * `devFlag` set it lazy-loads `MappingReviewDevMenu`, the fixture menu, so the
 * dev fixtures and the PDF intake dev staging they upload stay out of the
 * production entry chunk; without it, it renders nothing and loads nothing.
 * It needs no Router context: the menu navigates through the app's router.
 * Consumer: `ModelInput`.
 */
import { FC, lazy, Suspense } from 'react';
import { devFlag } from '@/config';

const MappingReviewDevMenu = lazy(() => import('./MappingReviewDevMenu'));

const MappingReviewDevLauncher: FC = () =>
  devFlag ? (
    <Suspense fallback={null}>
      <MappingReviewDevMenu />
    </Suspense>
  ) : null;

export default MappingReviewDevLauncher;
